// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"fdf9274c","315":"8e0a3248","414":"8db82dec","835":"1f289b96","878":"eceb7ec4","936":"2d726050"}[chunkId] + ".css";
};